import { Component, OnInit } from '@angular/core';
import {DiamondPayDataService} from "../diamond-pay-data-service.service";

@Component({
  selector: 'app-archived-transactions',
  templateUrl: './archived-transactions.component.html',
  styleUrls: ['./archived-transactions.component.css'],
  providers: [DiamondPayDataService]
})
export class ArchivedTransactionsComponent implements OnInit {
  private collection: any[];

  constructor(private dataService: DiamondPayDataService) { }

  ngOnInit() {
      this.dataService
            .retrieveArchivedTransactions()
            .subscribe((data:any[]) => this.collection = data, error => console.log(error));
  }

}



// WEBPACK FOOTER //
// ./src/app/archived-transactions/archived-transactions.component.ts